import VideoPreviewPlayer from "../VideoPreviewPlayer";

export default function PreviewStep({
  audioUrl,
  audioId = null,
  images,
  savedSegments = [],
  topic,
  aspectRatio = "16:9",
  onSegmentsChange,
  onExportVideo,
  onBack,
  isExporting,
  isSavingDraft = false,
  videoHistory = [],
  videoId = null,
  videoUrl = null,
  scriptId = null,
  onRefreshHistory,
  subtitleData = "",
  subtitlesEnabled = false,
  onSubtitlesChange,
  subtitleStyle = "default",
  onSubtitleStyleChange,
  animateVisuals = false,
  animationStats = null,
  onAnimationStatsChange,
  soundEffectClips = [],
  onSoundEffectClipsChange,
  showWatermark = true,
  initialSubtitleSettings = null,
  onSubtitleSettingsChange,
}) {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8 pb-24">

        {/* Back button */}
        <button
          onClick={onBack}
          disabled={isExporting}
          className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 font-medium transition-colors mb-6 disabled:opacity-50"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          Back to Scenes
        </button>

        {/* Header */}
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-2">
            <h1 className="text-xl font-semibold text-gray-900">Preview & Edit Timeline</h1>
            {isSavingDraft && (
              <span className="flex items-center gap-1.5 text-xs text-yellow-600 bg-yellow-50 px-2.5 py-1 rounded-full">
                <svg className="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                Saving...
              </span>
            )}
          </div>
          <p className="text-sm text-gray-500">
            Preview audio and images together. Drag segment edges to adjust timing, right-click to split or delete.
            <span className="text-primary-500 ml-1 font-medium">Changes are auto-saved.</span>
          </p>
        </div>

        {/* Topic badge */}
        <div className="mb-6">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-50 text-primary-700 text-xs font-medium rounded-lg border border-primary-100">
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {topic}
          </span>
        </div>

        {/* Video Preview Player with Timeline Editor */}
        <VideoPreviewPlayer
          audioUrl={audioUrl}
          images={images}
          savedSegments={savedSegments}
          aspectRatio={aspectRatio}
          onSegmentsChange={onSegmentsChange}
          onExportVideo={onExportVideo}
          isExporting={isExporting}
          isSavingDraft={isSavingDraft}
          videoHistory={videoHistory}
          onRefreshHistory={onRefreshHistory}
          subtitleData={subtitleData}
          subtitlesEnabled={subtitlesEnabled}
          onSubtitlesChange={onSubtitlesChange}
          subtitleStyle={subtitleStyle}
          onSubtitleStyleChange={onSubtitleStyleChange}
          audioId={audioId}
          animateVisuals={animateVisuals}
          animationStats={animationStats}
          onAnimationStatsChange={onAnimationStatsChange}
          soundEffectClips={soundEffectClips}
          onSoundEffectClipsChange={onSoundEffectClipsChange}
          showWatermark={showWatermark}
          initialSubtitleSettings={initialSubtitleSettings}
          onSubtitleSettingsChange={onSubtitleSettingsChange}
          videoId={videoId}
          videoUrl={videoUrl}
          topic={topic}
          scriptId={scriptId}
        />

      </div>
    </div>
  );
}
